export default __webpack_public_path__ + "static/media/flips_2027_packaged.b920c8d0.png";